import { Link } from "react-router-dom";
import { trackBlogCtaClick } from "../../util/analytics";
import styles from "./BlogCta.module.css";

interface BlogCtaProps {
  lang: "tr" | "en";
  // Attribution for the analytics event, e.g. the article slug.
  source: string;
}

// Copy lives here (not in languageData) because blog pages derive language
// from the URL: languageData follows the Redux language preference, which can
// disagree with the URL (an EN-preference user reading a /blog/... TR post),
// and the copy around a Turkish article must stay Turkish. Same pattern as
// BlogPost/BlogList.
const UI = {
  tr: {
    heading: "İstasyonunuzda vardiya kayıplarını durdurun",
    text: "Shift Tracker'ın nakit akışınızı nasıl banka onaylı hale getirdiğini 15 dakikalık bir demoda görün.",
    button: "Ücretsiz demo talep edin",
  },
  en: {
    heading: "Stop shift losses at your station",
    text: "See how Shift Tracker makes your cash flow bank-verified in a 15-minute demo.",
    button: "Request a free demo",
  },
};

/**
 * In-article call-to-action steering blog readers into the demo/contact funnel.
 * Links to the language-appropriate contact page and reports a `blog_cta_click`
 * analytics event.
 */
function BlogCta({ lang, source }: BlogCtaProps): JSX.Element {
  const ui = UI[lang];
  const prefix = lang === "en" ? "/en" : "";

  return (
    <aside className={styles.cta}>
      <h2 className={styles.heading}>{ui.heading}</h2>
      <p className={styles.text}>{ui.text}</p>
      <Link
        className={styles.button}
        to={`${prefix}/contact/`}
        onClick={() => trackBlogCtaClick(source)}
      >
        {/* The label needs its own colored element: the blog's
            ".page .container a { color: inherit }" reset outranks any
            single-class color on the anchor itself, which would leave the
            text white-on-white here. */}
        <span className={styles.buttonLabel}>{ui.button}</span>
      </Link>
    </aside>
  );
}

export default BlogCta;
